const locale = {
  'c.ModifyPassword.title': 'Изменить пароль',

  'c.ModifyPassword.label.oldPassword': 'Текущий пароль',
  'c.ModifyPassword.placeholder.oldPassword': 'Пожалуйста, введите текущий пароль',

  'c.ModifyPassword.label.newPassword': 'Новый пароль',
  'c.ModifyPassword.placeholder.newPassword':
    '8-26 символов (должен содержать заглавные, строчные буквы и цифры)',
  'c.ModifyPassword.rule.newPassword.min': 'Длина пароля не может быть меньше 8 символов!',
  'c.ModifyPassword.rule.newPassword.repeat': 'Новый пароль не может совпадать с текущим!',

  'c.ModifyPassword.label.confirmPassword': 'Подтвердите пароль',
  'c.ModifyPassword.placeholder.confirmPassword': 'Пожалуйста, подтвердите новый пароль',
  'c.ModifyPassword.rule.confirmPassword.inconsistent': 'Пароли не совпадают!',

  'c.ModifyPassword.button.submit': 'Сохранить',

  'c.ModifyPassword.request.loading': 'Изменение пароля...',
  'c.ModifyPassword.request.success': 'Пароль успешно изменен. Пожалуйста, войдите снова.',
  'c.ModifyPassword.request.error': 'Не удалось изменить пароль! Пожалуйста, попробуйте позже.',
};

export default locale;
